import React from 'react'
import Exbondview from '../../components/exbond/exbondview'  // Table or list of exbond records

export default function Exbond() {
    return (
        <>


        {/* View section to display existing exbond entries */}
        <div className='px-4'>
            <Exbondview/>
        </div>
        </>
    )
}
